
import {ModalVertical,Message} from 'tplus-components-touch'
import PwdKeyboard from '../components/pwdKeyboard'
import React,{Component} from 'react';

import {observer} from 'mobx-react';
import PropTypes from 'prop-types';
import {Action} from 'mutants-appfx'


/**
 * @props {boolean} visible
 * @props {fun} cancel 
 * @props {fun} ok
 * @props {string} title
 * @props {string} placeholder
 */
@observer
  class PwdModal extends Component {
    constructor(props,context){
      super(props,context)
      this.state={
        input:''
      }
    }

    static contextTypes = {
      onEvent:PropTypes.func,
      viewModel: PropTypes.object,
      stores:PropTypes.object,
      storeInfo:PropTypes.object,
      isReturn:PropTypes.bool,
      Idmember:PropTypes.number,
    }

    controllerEvent = (methodName, methodArgs) => {
      this.context.onEvent({ 'controllerEvent': Action.fromJS(this.context.viewModel, methodName) }, 'controllerEvent', methodArgs);
    }

   
  
    ok=()=>{
      const {ok} = this.props;
      if(ok){
        ok(this.state.input).then((result)=>{
          if(!result)return;
          this.setState({
            input:''
          })
        })
      } 
    }
  
    cancel=()=>{
      this.setState({
        input:''
      })
      this.props.cancel&&this.props.cancel()
    }
  
    render() {
      const {visible,title,placeholder,cardno,balance} = this.props;
      let footer=<span onClick={this.ok}></span>;
      return (
          <ModalVertical
            show={visible}
            animation={true}
            className='pwd-modal'
            // modalType={'small'}
            title={title}
            footer= {footer}
            backdrop={true}
            closeButton={true}
            cancel={this.cancel}
          >
            <div className='pwd-container'>
              <PwdKeyboard
                className='barcode-keyboard'
                cardno={cardno}
                balance={balance}
                input={this.state.input}
                changeVal={(val) => { this.setState( {input:val} ) } }
                placeholder={placeholder}
                ok={()=>this.ok()}
              ></PwdKeyboard>

            </div>
          </ModalVertical>
      );
  
    }
  }
  export default PwdModal;
  